import cls from "classnames";
import { useEffect, useState } from "react";
import { UserApiAccessFormData } from "../types";
// components
import { Button, Form, Input, Select } from "antd";

export const Step3Form: React.FC<{
  data: UserApiAccessFormData;
  visible: boolean;
  onPrev: () => void;
  onNext: (data: UserApiAccessFormData) => void;
  onCancel: () => void;
}> = ({ data, visible, onPrev, onNext, onCancel }) => {
  const [form] = Form.useForm<UserApiAccessFormData>();

  const [apiAccessMode, setApiAccessMode] = useState<number>(
    data.api_access_mode
  );

  const handleApiAccessModeChange = (value: number) => {
    setApiAccessMode(value);
  };

  useEffect(() => {
    form.resetFields();
    form.setFieldsValue(data);
  }, [data, form]);

  return (
    <Form
      form={form}
      labelCol={{ span: 4 }}
      className={cls(["mt:16", { hidden: !visible }])}
      onFinish={(values) => {
        onNext(values);
      }}
    >
      <Form.Item
        label="模式"
        colon={false}
        required={false}
        className="flex:1"
        name="api_access_mode"
      >
        <Select onChange={handleApiAccessModeChange}>
          <Select.Option value={0}>白名單</Select.Option>
          <Select.Option value={1}>黑名單</Select.Option>
        </Select>
      </Form.Item>

      {apiAccessMode === 0 && (
        <div>
          <h3 className="mb:12 t:center">白名單</h3>

          <Form.Item
            label="基礎功能"
            name="api_white_ips"
            extra="若有多筆 IP，請每筆一行輸入"
          >
            <Input.TextArea rows={4}></Input.TextArea>
          </Form.Item>

          <Form.Item
            label="代付功能"
            name="api_member_withdraw_white_ips"
            extra="若有多筆 IP，請每筆一行輸入"
          >
            <Input.TextArea rows={4}></Input.TextArea>
          </Form.Item>

          <Form.Item
            label="代收功能"
            name="api_member_deposit_white_ips"
            extra="若有多筆 IP，請每筆一行輸入"
          >
            <Input.TextArea rows={4}></Input.TextArea>
          </Form.Item>
        </div>
      )}

      {apiAccessMode === 1 && (
        <div>
          <h3 className="mb:12 t:center">黑名單</h3>

          <Form.Item
            label="基礎功能"
            name="api_black_ips"
            extra="若有多筆 IP，請每筆一行輸入"
          >
            <Input.TextArea rows={4}></Input.TextArea>
          </Form.Item>

          <Form.Item
            label="代付功能"
            name="api_member_withdraw_black_ips"
            extra="若有多筆 IP，請每筆一行輸入"
          >
            <Input.TextArea rows={4}></Input.TextArea>
          </Form.Item>

          <Form.Item
            label="代收功能"
            name="api_member_deposit_black_ips"
            extra="若有多筆 IP，請每筆一行輸入"
          >
            <Input.TextArea rows={4}></Input.TextArea>
          </Form.Item>
        </div>
      )}

      <Form.Item>
        <div className="flex jc:end gap:8">
          <Button htmlType="button" onClick={onCancel}>
            取消
          </Button>
          <Button htmlType="button" onClick={onPrev}>
            上一步
          </Button>
          <Button type="primary" htmlType="submit">
            下一步
          </Button>
        </div>
      </Form.Item>
    </Form>
  );
};
